import React from 'react';
import Landing from './pages/landing/Landing';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { oktaAuthConfig } from './utils/config';
import styles from './App.module.css';
import Spinner from './components/UI/spinner/Spinner';

const oktaAuth = new OktaAuth(oktaAuthConfig);

function App() {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  return (
    <div className={styles.appContainer}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Spinner />
      </Security>
    </div>
  );
}

export default App;
